import type { TokenSymbol } from '$lib/types/tokens';
import { writable, type Writable } from 'svelte/store';

export let depositOrWithdrawPopupToken: Writable<TokenSymbol> = writable();
